import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import {
  ACL,
  TICKET_TYPES,
  TICKETS_STATUSES
} from "../../../../../config/constants";
import {
  NOTIFICATION_TICKETS_ACTIONS
} from '../../../../../config/notifications';
import { TicketReasonModal } from '../../modals/TicketReasonModal';
import { updateTicket } from '../../../../../api/clients/tickets';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function RejectTicket(props) {
  const [ showRejectTicketModal, setShowRejectTicketModal ] = useState( false );

  const { index, actionCallback, ticket, showIcon } = props;

  const rejectTicket = (data) => {
    switch (data.ticket.type) {
      case TICKET_TYPES.DELETE_ORGANIZATION: {
        updateTicket( {
          ticket: data.ticket.id,
          data: {
            status: TICKETS_STATUSES.REJECTED,
            reason: data.reason,
          },
          notificationId: NOTIFICATION_TICKETS_ACTIONS
        } ).then( (response) => {
          setShowRejectTicketModal( false );

          if (response && response.data.id) {
            actionCallback();
          }
        } );
        break;
      }

      default: {
        updateTicket( {
          ticket: data.ticket.id,
          data: {
            status: TICKETS_STATUSES.REJECTED,
            reason: data.reason,
          },
          notificationId: NOTIFICATION_TICKETS_ACTIONS
        } ).then( (response) => {
          setShowRejectTicketModal( false );

          if (response && response.data.id) {
            actionCallback();
          }
        } );
        break;
      }
    }
  };

  const shouldHideActionBtn = () => {
    if (! ticket || ! ACL.CLIENT.TICKETS.MANAGE.hasAccess() || ticket.status !== TICKETS_STATUSES.NEW) {
      return true;
    }
  }

  if ( shouldHideActionBtn()) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`reject-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowRejectTicketModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_reject_ticket"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`reject-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_reject_ticket"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`reject-icon-` + props.index}
            onClick={() => setShowRejectTicketModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faBan}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`reject-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.ticket.table.actionButtons.confirm_reject_ticket"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <TicketReasonModal
        resolveTicket={false}
        showModal={showRejectTicketModal}
        closeModal={() => setShowRejectTicketModal( false )}
        confirmationYes={rejectTicket}
        ticket={ticket}
      />
    </Fragment>
  );
}

export { RejectTicket };
